export const tableHeaderSortOptions = {
  ASC: 'asc',
  DESC: 'desc'
}

export const tableHeaderTypeOptions = {
  TEXT: 'text',
  EMPTY: 'empty',
  CHECKBOX: 'checkbox',
  HANDLE: 'handle'
}

export const tableHeaderOrientationOptions = {
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right'
}

export const tableColumnSizeOptions = {
  XXS: 40,
  XS: 56,
  S: 80,
  M: 160,
  L: 240,
  XL: 360
}

export const tableItemsPerPageOptions = [
  {
    id: '1',
    title: 10
  },
  {
    id: '2',
    title: 15
  },
  {
    id: '3',
    title: 25
  },
  {
    id: '4',
    title: 50
  },
  {
    id: '5',
    title: 100
  }
]

export const rowDefaultAlignment = 'flex-start'

export const rowAlignmentMap = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end',
  start: 'flex-start',
  end: 'flex-end'
}
